import ESIInclude from '../../esi';

import classnames from 'classnames';
import styles from './Breadcrumbs.module.scss';
import { useBreadcrumbData } from './data/useBreadcrumbData';

export const getNvalFromUrl = (url: string) => {
  if (!url) return null;
  const lastSlash = url.lastIndexOf('/');
  return url.slice(lastSlash + 1);
};

export const EsiBreadcrumbs = ({ query, lastBreadcrumb }) => {
  const {
    type: routerPageType,
    'search-term': term,
    facetId,
    listHead,
  } = query;
  const { item, url } = lastBreadcrumb;
  let esiSource: string;

  switch (routerPageType) {
    case 'brand': {
      esiSource = `/esi/breadcrumbs/brand/${encodeURIComponent(item)}`;
      break;
    }

    case 'browse': {
      const [nVal] = facetId && facetId.length > 0 ? facetId.slice(-1) : [];
      const cVal = getNvalFromUrl(url);

      if (cVal && cVal.startsWith('c')) {
        esiSource = `/esi/breadcrumbs/category/${cVal.substring(1)}`;
      } else {
        if (nVal) esiSource = `/esi/breadcrumbs/browse/${nVal}`;
      }
      break;
    }

    default:
      esiSource = listHead
        ? `/esi/breadcrumbs/search/${encodeURIComponent(listHead)}`
        : `/esi/breadcrumbs/search/${encodeURIComponent(term)}`;
  }

  return (
    <div className={classnames(styles['breadcrumbs-carousel'])}>
      <ESIInclude src={esiSource} id="esiBreadcrumbs" />
    </div>
  );
};

export const Breadcrumbs = () => {
  const { breadcrumbs, query } = useBreadcrumbData();

  if (!(breadcrumbs?.length > 0)) {
    return null;
  }

  const [lastBreadcrumb] = breadcrumbs.slice(-1);

  return <EsiBreadcrumbs query={query} lastBreadcrumb={lastBreadcrumb} />;
};
